import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=15589a1e&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=ts&"
export * from "./orderList.vue?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=15589a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15589a1e",
  null
  
)

export default component.exports